import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonthSelectorComponent } from './month-selector/month-selector.component';
import { OlderMonthSelectorComponent } from './month-selector/older-month-selector/older-month-selector.component';

@NgModule({

  imports: [
    CommonModule,
  ],

  declarations: [MonthSelectorComponent, OlderMonthSelectorComponent],
  entryComponents:[OlderMonthSelectorComponent],
  exports: [MonthSelectorComponent]
})

export class UIModule { }
